import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledFullRefundThresholdInHoursField = styled(NumberInput)`
   z-index: 1;
   max-width: 68px;
`;

StyledFullRefundThresholdInHoursField.displayName = 'StyledFullRefundThresholdInHoursField';
